import React from 'react';
import { MDText } from 'i18n-react';

import { SavedSearchPopover } from 'Components/SavedSearch/SavedSearchPopover/SavedSearchPopover';
import LocalTexts from 'Components/shared/SavedFilters/SavedFilters.texts.json';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';
import useSavedFiltersStore, { useIsUniqueFilterInStore } from 'Stores/SavedFiltersStore/SavedFiltersStore';
import useStoreToast from 'Utilities/hooks/useStoreToast';

import SavedFiltersButton from './SavedFiltersButton/SavedFiltersButton';
import { triggerSavedFilterSaveChipHoverGAEvent } from './SavedFilters.analytics';
import { useSetIsUniqueFilter } from './useSetIsUniqueFilter';

import styles from './SavedFilters.module.scss';

const LocalT = new MDText(LocalTexts);

const SavedFilters: React.FC = () => {
	const {
		minWidth: { breakpointTablet: isDesktop },
	} = useBreakpoint();
	useStoreToast(useSavedFiltersStore);
	useSetIsUniqueFilter();
	const isUniqueFilter = useIsUniqueFilterInStore();

	const saveChipText = `${LocalT.translate('saveSearch')}`;

	return (
		<section className={styles.container}>
			<SavedSearchPopover />
			{isDesktop && (
				<div onMouseEnter={() => triggerSavedFilterSaveChipHoverGAEvent(isUniqueFilter)}>
					<SavedFiltersButton saveChipText={saveChipText} />
				</div>
			)}
		</section>
	);
};

export default SavedFilters;
